__turbopack_context__.v({
  "actionBtn": "ProspectList-module__3c7MUG__actionBtn",
  "actionQualify": "ProspectList-module__3c7MUG__actionQualify",
  "actionReject": "ProspectList-module__3c7MUG__actionReject",
  "actionsCell": "ProspectList-module__3c7MUG__actionsCell",
  "avatarSkeleton": "ProspectList-module__3c7MUG__avatarSkeleton",
  "bar": "ProspectList-module__3c7MUG__bar",
  "barSm": "ProspectList-module__3c7MUG__barSm",
  "card": "ProspectList-module__3c7MUG__card",
  "delete": "ProspectList-module__3c7MUG__delete",
  "empty": "ProspectList-module__3c7MUG__empty",
  "emptyText": "ProspectList-module__3c7MUG__emptyText",
  "emptyTitle": "ProspectList-module__3c7MUG__emptyTitle",
  "filterCell": "ProspectList-module__3c7MUG__filterCell",
  "header": "ProspectList-module__3c7MUG__header",
  "headerActions": "ProspectList-module__3c7MUG__headerActions",
  "list": "ProspectList-module__3c7MUG__list",
  "moreSignal": "ProspectList-module__3c7MUG__moreSignal",
  "placeholder": "ProspectList-module__3c7MUG__placeholder",
  "prospectCell": "ProspectList-module__3c7MUG__prospectCell",
  "prospectMeta": "ProspectList-module__3c7MUG__prospectMeta",
  "qualifyTip": "ProspectList-module__3c7MUG__qualifyTip",
  "realName": "ProspectList-module__3c7MUG__realName",
  "realProfile": "ProspectList-module__3c7MUG__realProfile",
  "realProspect": "ProspectList-module__3c7MUG__realProspect",
  "realScoreCell": "ProspectList-module__3c7MUG__realScoreCell",
  "realSignal": "ProspectList-module__3c7MUG__realSignal",
  "realSignals": "ProspectList-module__3c7MUG__realSignals",
  "realSub": "ProspectList-module__3c7MUG__realSub",
  "rejectTip": "ProspectList-module__3c7MUG__rejectTip",
  "row": "ProspectList-module__3c7MUG__row",
  "rowClickable": "ProspectList-module__3c7MUG__rowClickable",
  "score": "ProspectList-module__3c7MUG__score",
  "scoreCell": "ProspectList-module__3c7MUG__scoreCell",
  "scoreHeader": "ProspectList-module__3c7MUG__scoreHeader",
  "scoreHigh": "ProspectList-module__3c7MUG__scoreHigh",
  "scoreLow": "ProspectList-module__3c7MUG__scoreLow",
  "scoreMedium": "ProspectList-module__3c7MUG__scoreMedium",
  "scoreSkeleton": "ProspectList-module__3c7MUG__scoreSkeleton",
  "scrollWrapper": "ProspectList-module__3c7MUG__scrollWrapper",
  "signalsCell": "ProspectList-module__3c7MUG__signalsCell",
  "statusTag": "ProspectList-module__3c7MUG__statusTag",
  "statusTagQualified": "ProspectList-module__3c7MUG__statusTagQualified",
  "statusTagRejected": "ProspectList-module__3c7MUG__statusTagRejected",
  "tableHeader": "ProspectList-module__3c7MUG__tableHeader",
  "tableInner": "ProspectList-module__3c7MUG__tableInner",
  "title": "ProspectList-module__3c7MUG__title",
  "withActions": "ProspectList-module__3c7MUG__withActions",
});
